import React, { useState, useEffect, useRef } from 'react';
import { FaRegFileAlt, FaTimes } from "react-icons/fa";
import { LuDownload } from "react-icons/lu";
import { FiUpload } from "react-icons/fi";
import { IoLinkSharp } from "react-icons/io5";
import { FaArrowRight } from "react-icons/fa6";
import { FaChevronDown, FaChevronUp } from "react-icons/fa6";
import { IoAlertCircleOutline } from "react-icons/io5";
import ContactsPage from '../contacts/ContactsPage.jsx';
import Papa from "papaparse";
import { useToast } from '../../../context/ToastContext.jsx';
import server from '../../../api/server.js';
import "../../../dashboard-components/loader.css"
import ModernTimeDropdown from '../../layouts/modernDropdown.jsx';

const generateCallID = () => {
  const cryptoApi = typeof window !== 'undefined' ? window.crypto : null;
  if (typeof cryptoApi?.randomUUID === 'function') {
    return cryptoApi.randomUUID().replace(/-/g, '');
  }

  const bytes = new Uint8Array(16);
  if (typeof cryptoApi?.getRandomValues === 'function') {
    cryptoApi.getRandomValues(bytes);
  } else {
    for (let index = 0; index < bytes.length; index += 1) {
      bytes[index] = Math.floor(Math.random() * 256);
    }
  }
  bytes[6] = (bytes[6] & 0x0f) | 0x40;
  bytes[8] = (bytes[8] & 0x3f) | 0x80;
  return Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('');
};

const DataSourcesPage = ({serviceID, clientID, hitStatusApi}) => {
  const { showToast } = useToast();
  const [apiCallRunning, setApiCallRunning] = useState(false)
  const [uploadModalOpen, setUploadModalOpen] = useState(false);
  const [bulkUploadModalOpen, setBulkUploadModalOpen] = useState(false);
  const [showContactsModal, setShowContactsModal] = useState(false)
  const [showAdditionalFields, setShowAdditionalFields] = useState(false)
  const [statement, setStatement] = useState(null)
  const [loading, setLoading] = useState(false)
  const [service_id, setService_id] = useState('')
  const [client_id, setClient_id] = useState('')
  const [email, setEmail] = useState('')
  const [csvFile, setCsvFile] = useState('')
  const [projectStatus, setProjectStatus] = useState(null)
  const [csvFileName, setCsvFileName] = useState(null)
  const [callID, setCallID] = useState(generateCallID)
    const [employeeName, setEmployeeName] = useState('')
    const [callDate, setCallDate] = useState('')
    const [callTimeValue, setCallTimeValue] = useState('')
    const [customerID, setCustomerID] = useState('')
    const [callDirection, setCallDirection] = useState('')
    const [leadSource, setLeadSource] = useState('')
    const [leadSubSource, setLeadSubSource] = useState('')
    const [tag, setTag] = useState('')
    const [tag2, setTag2] = useState('')
    const [tag3, setTag3] = useState('')
    const [tag4, setTag4] = useState('')
    const [tag5, setTag5] = useState('')
    const [tag6, setTag6] = useState('')
    const [tag7, setTag7] = useState('')
    const [tag8, setTag8] = useState('')
    const [tag9, setTag9] = useState('')
    const [tag10, setTag10] = useState('')
    const [tag11, setTag11] = useState('')
    const [tag12, setTag12] = useState('')
    const [tag13, setTag13] = useState('')
    const [tag14, setTag14] = useState('')
    const [tag15, setTag15] = useState('')
    const [tag16, setTag16] = useState('')
    const [tag17, setTag17] = useState('')
    const [tag18, setTag18] = useState('')
    const [tag19, setTag19] = useState('')
    const [tag20, setTag20] = useState('')
    const [tag21, setTag21] = useState('')
    const [tag22, setTag22] = useState('')
    const [tag23, setTag23] = useState('')
    const [tag24, setTag24] = useState('')
    const [tag25, setTag25] = useState('')
    const [tag26, setTag26] = useState('')
    const [tag27, setTag27] = useState('')
    const [tag28, setTag28] = useState('')
    const [tag29, setTag29] = useState('')
    const [tag30, setTag30] = useState('')
    const [crmLeadStage, setCrmLeadStage] = useState('')
    const [crmLeadSubStage, setCrmLeadSubStage] = useState('')
    const [crmLocation, setCrmLocation] = useState('')
    const [customerPhoneNumber, setCustomerPhoneNumber] = useState('')
    const [crmLeadCreatedAtDate, setCrmLeadCreatedAtDate] = useState('')
    const [crmLeadCreatedAtTime, setCrmLeadCreatedAtTime] = useState('')
    const [crmFollowupDate, setCrmFollowupDate] = useState('')
    const [crmFollowupTime, setCrmFollowupTime] = useState('')
    const [campaignId, setCampaignId] = useState('')
    const [actorType, setActorType] = useState('')
    const [audioFile, setAudioFile] = useState('')
    const [fileData, setFileData] = useState(null)
  const requiredColumns = [
    "ID",
    "RECORDING LINK",
    "EMPLOYEE NAME",
    "CALL DATE",
    "CALL TIME",
    "CUSTOMER ID",
    "CALL DIRECTION",
  ];
  const optionalColumns = [
    "LEAD SOURCE",
    "LEAD SUB SOURCE",
    "TAG",
    "TAG2",
    "TAG3",
    "TAG4",
    "TAG5",
    "TAG6",
    "TAG7",
    "TAG8",
    "TAG9",
    "TAG10",
    "TAG11",
    "TAG12",
    "TAG13",
    "TAG14",
    "TAG15",
    "TAG16",
    "TAG17",
    "TAG18",
    "TAG19",
    "TAG20",
    "TAG21",
    "TAG22",
    "TAG23",
    "TAG24",
    "TAG25",
    "TAG26",
    "TAG27",
    "TAG28",
    "TAG29",
    "TAG30",
    "CAMPAIGN ID",
    "ACTOR TYPE",
    "CRM LEAD STAGE",
    "CRM LEAD SUB STAGE",
    "CRM LOCATION",
    "CUSTOMER PHONE NUMBER",
    "CRM LEAD CREATED AT DATE",
    "CRM LEAD CREATED AT TIME",
    "CRM FOLLOWUP DATE",
    "CRM FOLLOWUP TIME",
  ];
  const getBulkColumnLabel = (column) => {
    if (column === 'CRM LEAD CREATED AT DATE' || column === 'CRM FOLLOWUP DATE') {
      return `${column} (dd-mm-yyyy)`;
    }
    if (column === 'CRM LEAD CREATED AT TIME' || column === 'CRM FOLLOWUP TIME') {
      return `${column} (24-hour HH:MM)`;
    }
    return column;
  };
  const [user] = useState(()=> {
    const userCookie = getCookie('dashboard_login_user_creds');
    if (userCookie) {
      return JSON.parse(userCookie);
    }
    return { role: 'admin' };
  })
  const role = user.role;
  const uploadEmployeeName = role === 'employee' ? user.name : employeeName;
  const handleUploadSingle = () => {
    setUploadModalOpen(false)
    setBulkUploadModalOpen(false)
    showToast(projectStatus !== 'completed' ? "Record Upload Successful. Please configure the apps now." : "Record Upload Successful. We will notify once the analysis is ready.", "success");
  }

  const handleContactModal = (e) => {
    setShowContactsModal(false)
  }
  const handleDownloadSample = () => {
    const sampleFilePath = "/assets/sample_call_records.csv"; // Adjust the path if needed
  
    fetch(sampleFilePath)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = "sample.csv";
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
      })
      .catch((error) => console.error("Error downloading sample CSV:", error));
  };
  const isBlank = (value) => value === null || value === undefined || String(value).trim() === '';
  const normalizeTimeInput = (value) => String(value || '').trim().toUpperCase().replace(/\s+/g, ' ');
  const DEFAULT_OPTIONAL_TIME = '00:00';
  const parseTimeValue = (timeValue) => {
    const normalized = normalizeTimeInput(timeValue);
    const match = normalized.match(/^(\d{1,2}):(\d{2})$/);
    if (!match) return null;
    const hours = Number(match[1]);
    const minutes = Number(match[2]);
    if (hours < 0 || hours > 23 || minutes < 0 || minutes > 59) return null;
    return { hours, minutes };
  };
  const parseDateValue = (dateValue) => {
    const date = String(dateValue || '').trim();
    let match = date.match(/^(\d{4})-(\d{2})-(\d{2})$/);
    if (match) {
      return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
    }
    match = date.match(/^(\d{4})\/(\d{2})\/(\d{2})$/);
    if (match) {
      return { year: Number(match[1]), month: Number(match[2]), day: Number(match[3]) };
    }
    match = date.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (match) {
      return { year: Number(match[3]), month: Number(match[2]), day: Number(match[1]) };
    }
    return null;
  };
  const convertDateTimeToEpochIST = (dateValue, timeValue) => {
    const dateParts = parseDateValue(dateValue);
    const timeParts = parseTimeValue(timeValue);
    if (!dateParts || !timeParts) return null;
    const { year, month, day } = dateParts;
    const { hours, minutes } = timeParts;
    const parsedDate = new Date(year, month - 1, day);
    if (
      parsedDate.getFullYear() !== year ||
      parsedDate.getMonth() !== month - 1 ||
      parsedDate.getDate() !== day
    ) {
      return null;
    }
    const istDate = new Date(Date.UTC(year, month - 1, day, hours - 5, minutes - 30));
    return Math.floor(istDate.getTime() / 1000);
  };
  const getCsvValue = (row, key) => row[key] || row[key.replace(/\s+/g, '_')] || row[key.replace(/\s+/g, '')];
  const validateCsvRows = (rows) => {
    const currentEpoch = Math.floor(Date.now() / 1000);
    return rows.map((row, index) => {
      const rowNumber = index + 2;
      const callDateValue = getCsvValue(row, 'call date');
      const callTimeValue = getCsvValue(row, 'call time');
      const crmLeadCreatedAtDateValue = getCsvValue(row, 'crm lead created at date');
      const crmLeadCreatedAtTimeValue = getCsvValue(row, 'crm lead created at time');
      const crmFollowupDateValue = getCsvValue(row, 'crm followup date');
      const crmFollowupTimeValue = getCsvValue(row, 'crm followup time');

      if (!isBlank(crmLeadCreatedAtDateValue) && isBlank(crmLeadCreatedAtTimeValue)) {
        throw new Error(`Row ${rowNumber}: CRM LEAD CREATED AT DATE and CRM LEAD CREATED AT TIME should both be present.`);
      }
      if (isBlank(crmLeadCreatedAtDateValue) && !isBlank(crmLeadCreatedAtTimeValue)) {
        throw new Error(`Row ${rowNumber}: CRM LEAD CREATED AT DATE and CRM LEAD CREATED AT TIME should both be present.`);
      }
      if (!isBlank(crmFollowupDateValue) && isBlank(crmFollowupTimeValue)) {
        throw new Error(`Row ${rowNumber}: CRM FOLLOWUP DATE and CRM FOLLOWUP TIME should both be present.`);
      }
      if (isBlank(crmFollowupDateValue) && !isBlank(crmFollowupTimeValue)) {
        throw new Error(`Row ${rowNumber}: CRM FOLLOWUP DATE and CRM FOLLOWUP TIME should both be present.`);
      }
      if (isBlank(callDateValue) || isBlank(callTimeValue)) {
        throw new Error(`Row ${rowNumber}: CALL DATE and CALL TIME should both be present.`);
      }

      const epochCallTime = convertDateTimeToEpochIST(callDateValue, callTimeValue);
      if (!epochCallTime) {
        throw new Error(`Row ${rowNumber}: CALL DATE and CALL TIME must be valid. Use a valid date and 24-hour HH:MM.`);
      }
      if (epochCallTime > currentEpoch) {
        throw new Error(`Row ${rowNumber}: CALL DATE and CALL TIME cannot be in the future.`);
      }

      if (!isBlank(crmLeadCreatedAtDateValue)) {
        const crmLeadCreatedAtEpoch = convertDateTimeToEpochIST(crmLeadCreatedAtDateValue, crmLeadCreatedAtTimeValue);
        if (!crmLeadCreatedAtEpoch) {
          throw new Error(`Row ${rowNumber}: CRM LEAD CREATED AT DATE and CRM LEAD CREATED AT TIME must be valid.`);
        }
      }

      if (!isBlank(crmFollowupDateValue)) {
        const crmFollowupEpoch = convertDateTimeToEpochIST(crmFollowupDateValue, crmFollowupTimeValue);
        if (!crmFollowupEpoch) {
          throw new Error(`Row ${rowNumber}: CRM FOLLOWUP DATE and CRM FOLLOWUP TIME must be valid.`);
        }
      }

      return row;
    });
  };
  const appendOptionalFormValue = (formData, key, value) => {
    if (!isBlank(value)) {
      formData.append(key, value);
    }
  };
  const handleDateWithDefaultTimeChange = (value, setDate, timeValue, setTime) => {
    setDate(value);
    if (value && isBlank(timeValue)) {
      setTime(DEFAULT_OPTIONAL_TIME);
    }
    if (!value) {
      setTime('');
    }
  };
  const NativeDateInput = ({ id, label, value, onChange, required = false }) => (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>
        {label}{required ? '' : ' (Optional)'}
      </label>
      <input
        id={id}
        name={id}
        type="date"
        value={value}
        onChange={onChange}
        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
        style={{fontSize: "13px", padding: "0.4rem", height: "32px"}}
      />
    </div>
  );
  const TimeInput = ({ id, label, value, onTimeChange, required = false }) => (
    <div>
      <label htmlFor={id} className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>
        {label}{required ? '' : ' (Optional)'}
      </label>
      <input
        id={id}
        name={id}
        type="time"
        value={value}
        onChange={(e) => onTimeChange(e.target.value)}
        className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
        style={{fontSize: "13px", padding: "0.4rem", height: "32px"}}
      />
    </div>
  );
  const resetSingleUploadFields = () => {
    setAudioFile(null)
    setCallDirection('')
    setCallID(generateCallID())
    setCallDate('')
    setCallTimeValue('')
    setCustomerID('')
    setEmployeeName('')
    setLeadSource('')
    setLeadSubSource('')
    setTag('')
    setTag2('')
    setTag3('')
    setTag4('')
    setTag5('')
    setTag6('')
    setTag7('')
    setTag8('')
    setTag9('')
    setTag10('')
    setTag11('')
    setTag12('')
    setTag13('')
    setTag14('')
    setTag15('')
    setTag16('')
    setTag17('')
    setTag18('')
    setTag19('')
    setTag20('')
    setTag21('')
    setTag22('')
    setTag23('')
    setTag24('')
    setTag25('')
    setTag26('')
    setTag27('')
    setTag28('')
    setTag29('')
    setTag30('')
    setCrmLeadStage('')
    setCrmLeadSubStage('')
    setCrmLocation('')
    setCustomerPhoneNumber('')
    setCrmLeadCreatedAtDate('')
    setCrmLeadCreatedAtTime('')
    setCrmFollowupDate('')
    setCrmFollowupTime('')
    setCampaignId('')
    setActorType('')
    setShowAdditionalFields(false)
  };
  // Helper to parse CSV when needed (returns Promise)
  const parseCsvAsync = (file) => {
    return new Promise((resolve, reject) => {
      Papa.parse(file, {
        header: true,
        skipEmptyLines: true,
        transformHeader: (header) => header.trim().toLowerCase(),
        complete: (result) => {
          const headers = result.meta.fields.map((item) => item.trim().toLowerCase());
          const isValid = requiredColumns.every((col) => headers.includes(col.toLowerCase()));
          if (!isValid) {
            return reject(new Error("Invalid CSV format. Please use the provided sample."));
          }
          try {
            resolve(validateCsvRows(result.data));
          } catch (error) {
            reject(error);
          }
        },
        error: (err) => reject(err),
      });
    });
  };
  // keep latest selected file synchronously to avoid state timing issues
  const fileRef = useRef(null);
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;
    fileRef.current = file; // store synchronously
    setFileData(file)

    // Pre-parse the CSV so user gets faster feedback, but we still guard in handleBulkRecord.
    parseCsvAsync(file)
      .then((data) => {
        setCsvFileName(file.name);
        setCsvFile(data);
        setStatement('success');
      })
      .catch((err) => {
        console.error(err);
        fileRef.current = null;
        setFileData(null);
        setCsvFile(null);
        setCsvFileName(null);
        setStatement('error');
        showToast(err.message || "Invalid CSV format. Please use the provided sample.", "error");
      })
      .finally(() => {
        setTimeout(() => setStatement(null), 4000);
      });
  };
  const handleAudioUpload = (event) => {
    event.preventDefault();
    let file;
    
    if (event.dataTransfer) {
      file = event.dataTransfer.files[0];  // Dropped file
    } else {
      file = event.target.files[0];         // Selected file
    }
  
    if (file) {
      const allowedTypes = [
        "audio/mpeg",
        "audio/mp3",
        "audio/wav",
        "audio/wave",
        "audio/x-wav",
        "audio/ogg",
        "audio/mp4",
        "audio/x-m4a",
        "audio/aac",
        "audio/x-ms-wma",
      ];
      const allowedExtensions = ["wav", "mp3", "ogg", "m4a", "aac", "wma", "mp4a"];
      const fileExtension = file.name?.split('.').pop()?.toLowerCase();
      const maxSize = 100 * 1024 * 1024; // 100MB
  
      if (!allowedTypes.includes(file.type) && !allowedExtensions.includes(fileExtension)) {
        showToast("Only WAV, MP3, OGG, M4A, AAC, WMA, or MP4A audio files are allowed!", "error");
        return;
      }
  
      if (file.size > maxSize) {
        showToast("File size must be less than 100MB!", "error");
        return;
      }
  
      setAudioFile(file);
    }
  };    
  const handleSingleRecord = async () => {
    try {
      setLoading(true);

      // Convert callTime to epoch timestamp
      const epochCallTime = convertDateTimeToEpochIST(callDate, callTimeValue);
      const currentEpoch = Math.floor(Date.now() / 1000);
      if (!epochCallTime || !callID || !audioFile || !uploadEmployeeName || !customerID || !callDirection) {
        showToast("Please fill all required fields, including call date and call time.", "error")
        setLoading(false)
        return;
      }
      if (epochCallTime > currentEpoch) {
        showToast("Call Time cannot be in the future.", "error")
        setLoading(false);
        return;
      }
      let epochCrmLeadCreatedAt = null;
      if (!isBlank(crmLeadCreatedAtDate)) {
        epochCrmLeadCreatedAt = convertDateTimeToEpochIST(crmLeadCreatedAtDate, crmLeadCreatedAtTime);
        if (!epochCrmLeadCreatedAt) {
          showToast("CRM Lead Created At requires a valid time when date is selected.", "error")
          setLoading(false);
          return;
        }
      } else if (!isBlank(crmLeadCreatedAtTime)) {
        showToast("CRM Lead Created At time requires a date.", "error")
        setLoading(false);
        return;
      }
      let epochCrmFollowupTime = null;
      if (!isBlank(crmFollowupDate)) {
        epochCrmFollowupTime = convertDateTimeToEpochIST(crmFollowupDate, crmFollowupTime);
        if (!epochCrmFollowupTime) {
          showToast("CRM Followup Time requires a valid time when date is selected.", "error")
          setLoading(false);
          return;
        }
      } else if (!isBlank(crmFollowupTime)) {
        showToast("CRM Followup time requires a date.", "error")
        setLoading(false);
        return;
      }

      // Prepare FormData for the request
      const formData = new FormData();
      formData.append('id', callID);
      formData.append('audio', audioFile); // Append the audio file
      formData.append('employee_id', uploadEmployeeName);
      formData.append('call_time', epochCallTime); // Use the epoch timestamp
      formData.append('customer_id', customerID);
      formData.append('call_direction', callDirection);
      appendOptionalFormValue(formData, 'lead_source', leadSource);
      appendOptionalFormValue(formData, 'lead_sub_source', leadSubSource);
      appendOptionalFormValue(formData, 'campaign_id', campaignId);
      appendOptionalFormValue(formData, 'actor_type', actorType);
      formData.append('service_id', service_id);
      formData.append('client_id', client_id);
      formData.append('menu', 'data-sources');
      formData.append('submenu', undefined);
      formData.append('email', email);
      appendOptionalFormValue(formData, 'tag', tag);
      appendOptionalFormValue(formData, 'tag2', tag2);
      appendOptionalFormValue(formData, 'tag3', tag3);
      appendOptionalFormValue(formData, 'tag4', tag4);
      appendOptionalFormValue(formData, 'tag5', tag5);
      appendOptionalFormValue(formData, 'tag6', tag6);
      appendOptionalFormValue(formData, 'tag7', tag7);
      appendOptionalFormValue(formData, 'tag8', tag8);
      appendOptionalFormValue(formData, 'tag9', tag9);
      appendOptionalFormValue(formData, 'tag10', tag10);
      appendOptionalFormValue(formData, 'tag11', tag11);
      appendOptionalFormValue(formData, 'tag12', tag12);
      appendOptionalFormValue(formData, 'tag13', tag13);
      appendOptionalFormValue(formData, 'tag14', tag14);
      appendOptionalFormValue(formData, 'tag15', tag15);
      appendOptionalFormValue(formData, 'tag16', tag16);
      appendOptionalFormValue(formData, 'tag17', tag17);
      appendOptionalFormValue(formData, 'tag18', tag18);
      appendOptionalFormValue(formData, 'tag19', tag19);
      appendOptionalFormValue(formData, 'tag20', tag20);
      appendOptionalFormValue(formData, 'tag21', tag21);
      appendOptionalFormValue(formData, 'tag22', tag22);
      appendOptionalFormValue(formData, 'tag23', tag23);
      appendOptionalFormValue(formData, 'tag24', tag24);
      appendOptionalFormValue(formData, 'tag25', tag25);
      appendOptionalFormValue(formData, 'tag26', tag26);
      appendOptionalFormValue(formData, 'tag27', tag27);
      appendOptionalFormValue(formData, 'tag28', tag28);
      appendOptionalFormValue(formData, 'tag29', tag29);
      appendOptionalFormValue(formData, 'tag30', tag30);
      appendOptionalFormValue(formData, 'crm_lead_stage', crmLeadStage);
      appendOptionalFormValue(formData, 'crm_lead_sub_stage', crmLeadSubStage);
      appendOptionalFormValue(formData, 'crm_location', crmLocation);
      appendOptionalFormValue(formData, 'customer_phone_number', customerPhoneNumber);
      appendOptionalFormValue(formData, 'crm_lead_created_at', epochCrmLeadCreatedAt);
      appendOptionalFormValue(formData, 'crm_followup_time', epochCrmFollowupTime);
      let resp = await server.singleRecord(formData);
      if (resp.status === 200) {
        setUploadModalOpen(false)
        showToast(projectStatus !== 'completed' ? (role === 'employee' ? "Record Upload Successful." : "Record Upload Successful. Please configure the apps now.") : "Record Upload Successful. We will notify once the analysis is ready.", "success");
        if (!projectStatus || projectStatus === null || projectStatus === undefined){
          hitStatusApi('uploaded')
        }
      }
      resetSingleUploadFields()
      setLoading(false)
    } catch (error) {
      setLoading(false);
    }
  };
  
  const BulkUploadModal = ({ isOpen, onClose, onSave }) => {
    const [loading, setLoading] = useState(false);
    if (!isOpen) return null;
    const handleBulkRecord = async () => {
      try {
        if(apiCallRunning){
          return;
        }
        // ensure file is present
        if(!fileRef.current){
          showToast("Please upload a CSV file first.", "error");
          return;
        }
        setApiCallRunning(true);
        setLoading(true)
        // Ensure CSV content is ready – parse here if user clicked too quickly
        let csvContentLocal = csvFile;
        if (!csvContentLocal) {
          try {
            csvContentLocal = await parseCsvAsync(fileRef.current);
            setCsvFile(csvContentLocal); // cache for potential future use
          } catch(err) {
            showToast(err.message || "Failed to parse CSV", "error");
            setApiCallRunning(false);
            setLoading(false);
            return;
          }
        }

        let formData = new FormData();
        formData.append('file', fileRef.current);
        formData.append('content', JSON.stringify(csvContentLocal));
        formData.append('service_id', service_id);
        formData.append('client_id', client_id);
        formData.append('menu', 'data-sources');
        formData.append('submenu', undefined);
        formData.append('email', email);
        let res = await server.batchRecord(formData);
        let resp = await res.json();
        if(res.status === 200){
          setCsvFile(null)
          setCsvFileName(null)
          setFileData(null)
          setApiCallRunning(false)
          setLoading(false)
          if (!projectStatus || projectStatus === null || projectStatus === undefined){
            hitStatusApi('uploaded')
          }          
          onSave()
        }else{
          showToast(resp.message || resp.error || "Failed to upload records", "error");
          setApiCallRunning(false)
          setLoading(false)
        }
      } catch (error) {
        showToast(error.message || "Failed to upload records", "error");
        setApiCallRunning(false)
        setLoading(false)
      }
    }
    
    return (
      <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50 p-4" style={{background: "rgba(0,0,0,0.5)"}}>
        <div className="bg-white rounded-lg shadow-xl w-full" style={{height: "93vh", maxWidth: "800px"}}>
          <div className="p-4 border-b flex justify-between items-center">
            <h2 className="text-xl font-semibold" style={{fontSize: "18px"}}>Bulk Upload</h2>
            <FaTimes onClick={onClose} className='cursor-pointer h-4 w-4 text-slate-500' />
          </div>
          
          {!loading && <div className="p-4 space-y-4" style={{height: "76vh", overflow: "auto"}}>
            <div className="bg-blue-50 p-4 rounded-md flex items-start">
              <IoAlertCircleOutline className="text-blue-500 w-5 h-5 mt-0.5 mr-2 flex-shrink-0" />
              <div>
                <p className="text-sm text-blue-800">Your CSV should include the following fields:</p>
                <ul className="text-xs text-blue-700 mt-1 list-disc list-inside">
                  <li>ID</li>
                  <li>RECORDING LINK</li>
                  <li>EMPLOYEE NAME</li>
                  <li>CALL DATE (dd-mm-yyyy)</li>
                  <li>CALL TIME (24-hour HH:MM)</li>
                  <li>CUSTOMER ID</li>
                  <li>CALL DIRECTION (Inbound/Outbound)</li>
                  {optionalColumns.map((column) => (
                    <li key={column}>
                      {getBulkColumnLabel(column)} (Optional{['CRM LEAD CREATED AT TIME', 'CRM FOLLOWUP TIME'].includes(column) ? ', required if date is provided' : ''})
                    </li>
                  ))}
                </ul>
              </div>
            </div>
            
            <div className="flex items-center justify-center">
              <button onClick={handleDownloadSample} className="flex items-center gap-2 px-4 py-2 border border-indigo-600 text-indigo-600 rounded-md hover:bg-indigo-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px"}}>
                <LuDownload className="w-4 h-4" />
                Download sample CSV format
              </button>
            </div>
            
            <div className="mt-1 flex justify-center px-6 pt-5 pb-6 border-2 border-gray-300 border-dashed rounded-md">
              <div className="space-y-1 text-center">
                <FiUpload className="mx-auto h-12 w-12 text-gray-400" />
                <div className="flex text-sm text-gray-600 justify-center" style={{fontSize: "13px"}}>
                  <label className="relative cursor-pointer rounded-md font-medium text-indigo-600">
                    <span>Upload a CSV file</span>
                    <input type="file" accept=".csv" className="global-input sr-only" onChange={handleFileUpload} />
                  </label>
                  <p className="pl-1">or drag and drop</p>
                </div>
                <p className="text-xs text-gray-500">CSV up to 50MB</p>
                {csvFile && (
                    <div className="mt-2">
                      <p className="text-sm text-gray-700">{csvFileName}</p>
                    </div>
                  )}
              </div>
            </div>
            {statement && (<div style={{textAlign: "center", fontSize: "13px", color: (statement === 'success') ? "green":"red"}}>{statement === 'success' ? '':'Invalid CSV format. Please use the provided sample format.'}</div>)}
          </div>}
          {loading && (<div className="flex justify-center items-center" style={{ height: "77vh", flexDirection: "column" }}>
                        <div className="loader"></div>
                        <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                      </div>)}
          
          <div className="p-4 border-t flex justify-end gap-3">
            <button 
              onClick={onClose} 
              className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px"}}
            >
              Cancel
            </button>
            <button onClick={handleBulkRecord} disabled={apiCallRunning}
              className={`px-4 py-2 ${apiCallRunning ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'} text-white rounded-md`}
              style={{ padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
            >
              Upload
            </button>
          </div>
        </div>
      </div>
    );
  };

  function getCookie(name) {
      function escape(s) { return s.replace(/([.*+?\^$(){}|\[\]\/\\])/g, '\\$1'); }
      var match = document.cookie.match(RegExp('(?:^|;\\s*)' + escape(name) + '=([^;]*)'));
      return match ? match[1] : null;
  }
  const getProjectStatus = async () => {
    try {
      let res = await server.getProjectStatus(client_id, service_id, email, role === 'employee' ? 'data-sources' : 'apps', undefined, window.location.href)
      if(res.status === 200){
        let resp = await res.json();
        setProjectStatus(resp.data)
      }
    } catch (error) {
    }
  }

  useEffect(()=> {
      const user = getCookie('dashboard_login_user_creds') ? JSON.parse(getCookie('dashboard_login_user_creds')) : null;
      setEmail(user.email);
      if(serviceID){
        setService_id(serviceID)
      }
      if(clientID){
        setClient_id(clientID)
      }
  }, [serviceID, clientID])
  useEffect(()=> {
    if(email && client_id && service_id){
      getProjectStatus();
    }
  }, [client_id, service_id, email])

  // Close modals when the Escape key is pressed
  useEffect(() => {
    const handleEsc = (event) => {
      if (event.key === "Escape") {
        if (uploadModalOpen) {
          setUploadModalOpen(false);
        }
        if (bulkUploadModalOpen) {
          setBulkUploadModalOpen(false);
        }
        if (showContactsModal) {
          setShowContactsModal(false);
        }
      }
    };

    // Attach listener only when any modal is open
    if (uploadModalOpen || bulkUploadModalOpen || showContactsModal) {
      window.addEventListener('keydown', handleEsc);
    }

    return () => {
      window.removeEventListener('keydown', handleEsc);
    };
  }, [uploadModalOpen, bulkUploadModalOpen, showContactsModal]);

  return (
    <div className="flex items-center justify-center py-3" style={{height: "100%", marginTop: (role==='employee') ? "2rem":"", background: "rgb(249, 250, 251)"}}>
      {/* Main Content */}
      <div className="flex-1 overflow-auto" style={{height: "100%"}}>
        <div className="px-5">
          <div className="mb-6">
            <h1 className="text-xl font-semibold text-gray-900 mb-2">Data Sources</h1>
            <p className="text-gray-500 text-sm">Upload and integrate your call data</p>
          </div>

          {/* Upload Section */}
          <div className="mb-6">
            <h2 className="text-xl font-semibold mb-4" style={{fontSize: "1rem"}}>Upload</h2>
            <div className="flex flex-row space-x-6 max-w-6xl">
              {/* Single Record Upload Card */}
              <div className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-6 flex-1">
                <div className="flex items-center">
                  <div className="p-3 rounded-lg mr-4" style={{ backgroundColor: 'rgba(79, 70, 229, 0.1)' }}>
                    <FiUpload className="w-8 h-8 text-black" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-1" style={{fontSize: "1rem"}}>Upload Single Record</h3>
                    <p className="text-gray-600 text-sm" style={{fontSize: "13px"}}>Upload individual call recordings and metadata</p>
                  </div>
                  <button 
                    onClick={() => {setUploadModalOpen(true); setLoading(false);}} 
                    className="px-5 py-2 text-white rounded-md hover:bg-opacity-90 font-medium shadow-sm"
                    style={{ backgroundColor: 'rgb(79, 70, 229)', padding: "0.3rem 1.4rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
                  >
                    Upload
                  </button>
                </div>
              </div>
                
              {/* Bulk Upload Card */}
              {role !== 'employee' && <div className="bg-white rounded-lg shadow-sm hover:shadow-md transition-shadow p-6 flex-1">
                <div className="flex items-center">
                  <div className="p-3 rounded-lg mr-4" style={{ backgroundColor: 'rgba(79, 70, 229, 0.1)' }}>
                    <FaRegFileAlt className="w-8 h-8 text-black" />
                  </div>
                  <div className="flex-1">
                    <h3 className="font-semibold text-lg mb-1" style={{fontSize: "1rem"}}>Bulk Upload</h3>
                    <p className="text-gray-600 text-sm" style={{fontSize: "13px"}}>Upload multiple records via CSV file</p>
                  </div>
                  <button 
                    onClick={() => {setBulkUploadModalOpen(true); setCsvFile(null); setCsvFileName(null);}} 
                    className="px-5 py-2 text-white rounded-md hover:bg-opacity-90 font-medium shadow-sm"
                    style={{ backgroundColor: 'rgb(79, 70, 229)', padding: "0.3rem 1.4rem", fontSize: "14px",height: "40px", borderRadius: "4px" }}
                  >
                    Upload
                  </button>
                </div>
              </div>}
            </div>
          </div>

          {/* Integrations Section */}
          {role !== 'employee' && <div>
            <h2 className="text-xl font-semibold mb-4">Integrations</h2>
            <div className="bg-white p-5 rounded-lg border shadow-sm text-center max-w-6xl">
              <div className="flex flex-col items-center justify-center py-4">
                <div className="p-5 rounded-full mb-4" style={{ backgroundColor: 'rgba(79, 70, 229, 0.1)' }}>
                  <IoLinkSharp className="w-8 h-8" />
                </div>
                <h3 className="text-xl font-semibold mb-2" style={{fontSize: "1rem"}}>Integrations Coming Soon</h3>
                <p className="text-gray-600 max-w-md mx-auto mb-6" style={{fontSize: "13px"}}>
                  We're working on adding integrations with popular CRM and telephony platforms. 
                  Stay tuned for updates!
                </p>
                <button 
                  className="flex items-center gap-2 px-5 py-2.5 text-white rounded-md hover:bg-opacity-90"
                  style={{ backgroundColor: 'rgb(79, 70, 229)', padding: "0.5rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }} onClick={()=> setShowContactsModal(true)}
                >
                  Request Integration <FaArrowRight className="w-4 h-4" />
                </button>
              </div>
            </div>
          </div>}
        </div>
      </div>
      
      {role !== 'employee' && <BulkUploadModal
        isOpen={bulkUploadModalOpen} 
        onClose={() => setBulkUploadModalOpen(false)}  onSave={handleUploadSingle}
      />}
      {
        showContactsModal && <ContactsPage state={handleContactModal} category={'Feature Request'} serviceID={serviceID} />
      }
      {
        uploadModalOpen && (
          <div className="fixed inset-0 bg-black bg-opacity-25 flex items-center justify-center z-50 p-4" style={{background: "rgba(0,0,0,0.5)"}}>
            <div className="bg-white rounded-lg shadow-xl w-full" style={{height: "93vh", maxWidth: "800px"}}>
              <div className="p-4 border-b flex justify-between items-center">
                <h2 className="text-xl font-semibold" style={{fontSize: "18px"}}>Upload Single Record</h2>
                <FaTimes onClick={()=> setUploadModalOpen(false)} className='cursor-pointer h-4 w-4 text-slate-500' />
              </div>
              
              {!loading && <div className="px-4 py-2 space-y-2" style={{height: "76vh", overflow: "auto"}}>
                <div>
                  <label htmlFor='callID' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Call ID</label>
                  <input class="global-input"
                    id='callID' name='callID' type="text" value={callID} onChange={(e)=> setCallID(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                    placeholder="Enter call ID" style={{fontSize: "13px", padding: "0.4rem"}}
                  />
                </div>
                
                <div>
                  <label htmlFor='audio' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Upload Audio</label>
                  <div className="mt-1 flex justify-center px-6 pt-3 pb-3 border-2 border-gray-300 border-dashed rounded-md"
                  onDragOver={(e) => e.preventDefault()}
                  onDrop={handleAudioUpload}>
                    <div className="space-y-1 text-center">
                      <FiUpload className="mx-auto h-10 w-10 text-gray-400" />
                      <div className="flex text-sm text-gray-600 justify-center" style={{fontSize: "13px"}}>
                        <label htmlFor='audio' className="relative cursor-pointer rounded-md font-medium text-indigo-600">
                          <span>Upload a file</span>
                          <input class="global-input"id='audio' name='audio' type="file" className="sr-only" onChange={handleAudioUpload} accept=".wav,.mp3,.ogg,.m4a,.aac,.wma,.mp4a,audio/wav,audio/mpeg,audio/ogg,audio/mp4,audio/aac,audio/x-ms-wma" />
                        </label>
                        <p className="pl-1">or drag and drop</p>
                      </div>
                      <p className="text-xs text-gray-500" style={{fontSize: "12px"}}>WAV, MP3, OGG, M4A, AAC, WMA, MP4A up to 100MB</p>
                      {audioFile && (
                        <div className="mt-2">
                          <p className="text-sm text-gray-700">{audioFile.name}</p>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                
                <div>
                  <label htmlFor='employeeName' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Employee Name</label>
                  <input class="global-input"
                    id='employeeName' name='employeeName' type="text" value={uploadEmployeeName} readOnly={role === 'employee'} onChange={(e)=> setEmployeeName(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                    placeholder="Enter employee name" style={{fontSize: "13px", padding: "0.4rem"}}
                  />
                </div>
                
                <div className="grid grid-cols-2 gap-3">
                  <NativeDateInput
                    id="callDate"
                    label="Call Date"
                    value={callDate}
                    onChange={(e)=>handleDateWithDefaultTimeChange(e.target.value, setCallDate, callTimeValue, setCallTimeValue)}
                    required
                  />
                  <TimeInput
                    id="callTime"
                    label="Call Time"
                    value={callTimeValue}
                    onTimeChange={setCallTimeValue}
                    required
                  />
                </div>
                
                <div>
                  <label htmlFor='customerID' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Customer ID</label>
                  <input class="global-input"
                    id='customerID' name='customerID' type="text" value={customerID} onChange={(e)=> setCustomerID(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                    placeholder="Enter customer ID" style={{fontSize: "13px", padding: "0.4rem"}}
                  />
                </div>
                
                <div>
                  <label htmlFor='callDirection' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Call Direction</label>
                  <ModernTimeDropdown width='w-full' placeholder="Select direction" id='callDirection' name='callDirection' value={callDirection} onChange={(e)=> setCallDirection(e.target.value)} options={['Inbound', 'Outbound']}/>
                </div>
                <div className="flex items-center justify-between w-[30%] mb-1">
                  <div className="text-sm font-medium text-gray-700" style={{fontSize: "13px"}}>Additional fields</div>
                  <button type="button" className="text-xs cursor-pointer" onClick={() => setShowAdditionalFields((prev) => !prev)}>
                    {showAdditionalFields ? <FaChevronUp size={10} /> : <FaChevronDown size={10} />}
                  </button>
                </div>
                {showAdditionalFields && (
                  <>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label htmlFor='leadSource' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Lead Source (Optional)</label>
                    <input class="global-input"
                      id='leadSource' name='leadSource' type="text" value={leadSource} onChange={(e)=> setLeadSource(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter lead source" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='leadSubSource' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Lead Sub Source (Optional)</label>
                    <input class="global-input"
                      id='leadSubSource' name='leadSubSource' type="text" value={leadSubSource} onChange={(e)=> setLeadSubSource(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter lead sub source" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-3 gap-3">
                  <div>
                    <label htmlFor='tag' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag (Optional)</label>
                    <input class="global-input"
                      id='tag' name='tag' type="text" value={tag} onChange={(e)=> setTag(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag2' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag2 (Optional)</label>
                    <input class="global-input"
                      id='tag2' name='tag2' type="text" value={tag2} onChange={(e)=> setTag2(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag2" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag3' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag3 (Optional)</label>
                    <input class="global-input"
                      id='tag3' name='tag3' type="text" value={tag3} onChange={(e)=> setTag3(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag3" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag4' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag4 (Optional)</label>
                    <input class="global-input"
                      id='tag4' name='tag4' type="text" value={tag4} onChange={(e)=> setTag4(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag4" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag5' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag5 (Optional)</label>
                    <input class="global-input"
                      id='tag5' name='tag5' type="text" value={tag5} onChange={(e)=> setTag5(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag5" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag6' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag6 (Optional)</label>
                    <input class="global-input"
                      id='tag6' name='tag6' type="text" value={tag6} onChange={(e)=> setTag6(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag6" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag7' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag7 (Optional)</label>
                    <input class="global-input"
                      id='tag7' name='tag7' type="text" value={tag7} onChange={(e)=> setTag7(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag7" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag8' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag8 (Optional)</label>
                    <input class="global-input"
                      id='tag8' name='tag8' type="text" value={tag8} onChange={(e)=> setTag8(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag8" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag9' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag9 (Optional)</label>
                    <input class="global-input"
                      id='tag9' name='tag9' type="text" value={tag9} onChange={(e)=> setTag9(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag9" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag10' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag10 (Optional)</label>
                    <input class="global-input"
                      id='tag10' name='tag10' type="text" value={tag10} onChange={(e)=> setTag10(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag10" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag11' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag11 (Optional)</label>
                    <input class="global-input"
                      id='tag11' name='tag11' type="text" value={tag11} onChange={(e)=> setTag11(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag11" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag12' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag12 (Optional)</label>
                    <input class="global-input"
                      id='tag12' name='tag12' type="text" value={tag12} onChange={(e)=> setTag12(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag12" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag13' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag13 (Optional)</label>
                    <input class="global-input"
                      id='tag13' name='tag13' type="text" value={tag13} onChange={(e)=> setTag13(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag13" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag14' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag14 (Optional)</label>
                    <input class="global-input"
                      id='tag14' name='tag14' type="text" value={tag14} onChange={(e)=> setTag14(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag14" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag15' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag15 (Optional)</label>
                    <input class="global-input"
                      id='tag15' name='tag15' type="text" value={tag15} onChange={(e)=> setTag15(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag15" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag16' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag16 (Optional)</label>
                    <input class="global-input"
                      id='tag16' name='tag16' type="text" value={tag16} onChange={(e)=> setTag16(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag16" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag17' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag17 (Optional)</label>
                    <input class="global-input"
                      id='tag17' name='tag17' type="text" value={tag17} onChange={(e)=> setTag17(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag17" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag18' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag18 (Optional)</label>
                    <input class="global-input"
                      id='tag18' name='tag18' type="text" value={tag18} onChange={(e)=> setTag18(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag18" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag19' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag19 (Optional)</label>
                    <input class="global-input"
                      id='tag19' name='tag19' type="text" value={tag19} onChange={(e)=> setTag19(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag19" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag20' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag20 (Optional)</label>
                    <input class="global-input"
                      id='tag20' name='tag20' type="text" value={tag20} onChange={(e)=> setTag20(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag20" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag21' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag21 (Optional)</label>
                    <input class="global-input"
                      id='tag21' name='tag21' type="text" value={tag21} onChange={(e)=> setTag21(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag21" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag22' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag22 (Optional)</label>
                    <input class="global-input"
                      id='tag22' name='tag22' type="text" value={tag22} onChange={(e)=> setTag22(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag22" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag23' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag23 (Optional)</label>
                    <input class="global-input"
                      id='tag23' name='tag23' type="text" value={tag23} onChange={(e)=> setTag23(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag23" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag24' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag24 (Optional)</label>
                    <input class="global-input"
                      id='tag24' name='tag24' type="text" value={tag24} onChange={(e)=> setTag24(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag24" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag25' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag25 (Optional)</label>
                    <input class="global-input"
                      id='tag25' name='tag25' type="text" value={tag25} onChange={(e)=> setTag25(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag25" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag26' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag26 (Optional)</label>
                    <input class="global-input"
                      id='tag26' name='tag26' type="text" value={tag26} onChange={(e)=> setTag26(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag26" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag27' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag27 (Optional)</label>
                    <input class="global-input"
                      id='tag27' name='tag27' type="text" value={tag27} onChange={(e)=> setTag27(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag27" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag28' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag28 (Optional)</label>
                    <input class="global-input"
                      id='tag28' name='tag28' type="text" value={tag28} onChange={(e)=> setTag28(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag28" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag29' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag29 (Optional)</label>
                    <input class="global-input"
                      id='tag29' name='tag29' type="text" value={tag29} onChange={(e)=> setTag29(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag29" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='tag30' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Tag30 (Optional)</label>
                    <input class="global-input"
                      id='tag30' name='tag30' type="text" value={tag30} onChange={(e)=> setTag30(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter tag30" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label htmlFor='crmLeadStage' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>CRM Lead Stage (Optional)</label>
                    <input class="global-input"
                      id='crmLeadStage' name='crmLeadStage' type="text" value={crmLeadStage} onChange={(e)=> setCrmLeadStage(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter CRM lead stage" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='crmLeadSubStage' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>CRM Lead Sub Stage (Optional)</label>
                    <input class="global-input"
                      id='crmLeadSubStage' name='crmLeadSubStage' type="text" value={crmLeadSubStage} onChange={(e)=> setCrmLeadSubStage(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter CRM lead sub stage" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <div>
                    <label htmlFor='crmLocation' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>CRM Location (Optional)</label>
                    <input class="global-input"
                      id='crmLocation' name='crmLocation' type="text" value={crmLocation} onChange={(e)=> setCrmLocation(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter CRM location" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                  <div>
                    <label htmlFor='customerPhoneNumber' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Customer Phone Number (Optional)</label>
                    <input class="global-input"
                      id='customerPhoneNumber' name='customerPhoneNumber' type="text" value={customerPhoneNumber} onChange={(e)=> setCustomerPhoneNumber(e.target.value)}
                      className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                      placeholder="Enter customer phone number" style={{fontSize: "13px", padding: "0.4rem"}}
                    />
                  </div>
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <NativeDateInput
                    id="crmLeadCreatedAtDate"
                    label="CRM Lead Created At Date"
                    value={crmLeadCreatedAtDate}
                    onChange={(e)=>handleDateWithDefaultTimeChange(e.target.value, setCrmLeadCreatedAtDate, crmLeadCreatedAtTime, setCrmLeadCreatedAtTime)}
                  />
                  <TimeInput
                    id="crmLeadCreatedAtTime"
                    label="CRM Lead Created At Time"
                    value={crmLeadCreatedAtTime}
                    onTimeChange={setCrmLeadCreatedAtTime}
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                  <NativeDateInput
                    id="crmFollowupDate"
                    label="CRM Followup Date"
                    value={crmFollowupDate}
                    onChange={(e)=>handleDateWithDefaultTimeChange(e.target.value, setCrmFollowupDate, crmFollowupTime, setCrmFollowupTime)}
                  />
                  <TimeInput
                    id="crmFollowupTime"
                    label="CRM Followup Time"
                    value={crmFollowupTime}
                    onTimeChange={setCrmFollowupTime}
                  />
                </div>
                <div className="grid grid-cols-2 gap-3">
                <div>
                  <label htmlFor='campaignId' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Campaign ID (Optional)</label>
                  <input class="global-input"
                    id='campaignId' name='campaignId' type="text" value={campaignId} onChange={(e)=> setCampaignId(e.target.value)}
                    className="w-full p-2 border border-gray-300 rounded-md focus:outline-none global-input"
                    placeholder="Enter campaign ID" style={{fontSize: "13px", padding: "0.4rem"}}
                  />
                </div>
                <div>
                  <label htmlFor='actorType' className="block text-sm font-medium text-gray-700 mb-1" style={{fontSize: "13px", marginBottom: "0.1rem"}}>Actor Type (Optional)</label>
                  <ModernTimeDropdown width='w-full' placeholder="Select actor type" id='actorType' name='actorType' value={actorType} onChange={(e)=> setActorType(e.target.value)} options={['Human Agent', 'AI Agent']}/>
                </div>
                </div>
                  </>
                )}
              </div>}
               {loading && (<div className="flex justify-center items-center" style={{ height: "78vh", flexDirection: "column" }}>
                            <div className="loader"></div>
                            <div style={{textAlign: "center"}}>Loading <br/> Please Wait</div>
                          </div>)}
              
              <div className="p-4 border-t flex justify-end gap-3">
                <button 
                  onClick={() => {setUploadModalOpen(false); resetSingleUploadFields()}} 
                  className="px-4 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50" style={{padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px"}}
                >
                  Cancel
                </button>
                <button onClick={handleSingleRecord} disabled={loading}
                  className={`px-4 py-2 ${loading ? 'bg-gray-400 cursor-not-allowed' : 'bg-indigo-600 hover:bg-indigo-700'} text-white rounded-md`}
                  style={{padding: "0.3rem 1.3rem", fontSize: "14px", height: "40px", borderRadius: "4px" }}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        )
      }
    </div>
  );
};

export default DataSourcesPage;
